import { render, staticRenderFns } from "./CriteriaAndProceduresSection.vue?vue&type=template&id=650af4ea&scoped=true"
import script from "./CriteriaAndProceduresSection.vue?vue&type=script&lang=js"
export * from "./CriteriaAndProceduresSection.vue?vue&type=script&lang=js"
import style0 from "./CriteriaAndProceduresSection.vue?vue&type=style&index=0&id=650af4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650af4ea",
  null
  
)

export default component.exports